import axios from "axios";
import { BASE_URL } from "../../../Helper/Helper";
const LeadState = {
  addLead: async (requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/create-lead`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("response", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  getLead: async (params) => {
    const response = await axios.get(`${BASE_URL}/api/v2/admin/get-lead`, {
      params,
      headers: {
        token: localStorage.getItem("token"),
      },
    });

    // console.log("lead-state-res---", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  getLeadById: async (id) => {
    // FETCH API CALL For all notes
    const response = await axios.get(
      `${BASE_URL}/api/v2/admin/getbyid-lead/${id}`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("response", response);
    let datas = response.data.data;
    // console.log("datas", datas);
    return datas;
  },

  deleteLead: async (id) => {
    const response = await axios.delete(
      `${BASE_URL}/api/v2/admin/delete-lead/${id}`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateLead: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/update-lead/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("res", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateLeadById: async (id, updatedFiles) => {
    // FETCH API CALL For all files
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/single-lead/${id}`,
      updatedFiles,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateLeadStatus: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/lead-status/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateLeadTags: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/lead-tags/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateLeadTabStatus: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/lead-tab-status/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateLeadTabNotes: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/lead-tab-notes/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  updateLeadShareCount: async (id, requestOptions) => {
    // FETCH API CALL For all notes
    const response = await axios.post(
      `${BASE_URL}/api/v2/admin/lead-share/${id}`,
      requestOptions,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  getFollowLeadByLeadId: async (id) => {
    // FETCH API CALL For all notes
    const response = await axios.get(
      `${BASE_URL}/api/v2/admin/getfollow-lead/${id}`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("response", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  getDashLead: async () => {
    const response = await axios.get(`${BASE_URL}/api/v2/admin/getlead-dash`, {
      headers: {
        token: localStorage.getItem("token"),
      },
    });

    // console.log("lead-state-res---", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  getDashLeadChart: async () => {
    const response = await axios.get(`${BASE_URL}/api/v2/admin/getlead-chart`, {
      headers: {
        token: localStorage.getItem("token"),
      },
    });

    // console.log("lead-state-res---", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  getDashLeadCalls: async () => {
    const response = await axios.get(
      `${BASE_URL}/api/v2/admin/getlead-dash-calls`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("lead-state-res---", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  getDashActivityOnLeads: async () => {
    const response = await axios.get(
      `${BASE_URL}/api/v2/admin/getlead-dash-activity-on-leads`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("lead-state-res---", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  getDashScheduleMeetingsLead: async () => {
    const response = await axios.get(
      `${BASE_URL}/api/v2/admin/getlead-dash-scheduled-meetings`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("lead-state-res---", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  getDashScheduleSiteVisitLead: async () => {
    const response = await axios.get(
      `${BASE_URL}/api/v2/admin/getlead-dash-schedule-site-visit`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("lead-state-res---", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },

  getDashLeadReports: async () => {
    const response = await axios.get(
      `${BASE_URL}/api/v2/admin/getlead-dash-lead-reports`,
      {
        headers: {
          token: localStorage.getItem("token"),
        },
      }
    );

    // console.log("lead-state-res---", response);
    let datas = response.data;
    // console.log("datas", datas);
    return datas;
  },
};

export default LeadState;
